
import React from 'react';
import moment from 'moment';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Grid, Radio, RadioGroup, FormControlLabel, TextField } from '@mui/material';
import { makeStyles } from "@mui/styles";


const useStyles = makeStyles((theme) => ({
    time: {
        display: 'flex',
        alignItems: 'center',
        [theme.breakpoints.down("sm")]: {
            display: 'block'
        }
    }
}))

export default function LeaveDate(props) {
    const { dateValue, handleChangeDate,
        isMandatory, startFieldName, endFieldName, errorMsgList } = props;

    const classes = useStyles();

    let endTime = dateValue[endFieldName];
    let startTime = dateValue[startFieldName];
    let formatEndTime = endTime ? moment(endTime, 'DD-MM-YYYY').format() : null;
    let formatStartTime = startTime ? moment(startTime, 'DD-MM-YYYY').format() : null;

    return (
        <Grid container alignItems="center" spacing={{ xs: 0, md: 2 }}>
            <Grid item>Leave from 由</Grid>
            <Grid item xs={12} md={2}>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DatePicker
                        id={'DateTimePicker_From_Date'}
                        openTo="year"
                        views={['year', 'month', 'day']}
                        value={formatStartTime}
                        onChange={(valDate) => {
                            handleChangeDate(moment(valDate).format('DD-MM-YYYY'), startFieldName);
                        }}
                        renderInput={(params) =>
                            <TextField {...params}
                                //placeholder="DD-MM-YYYY"
                                variant="outlined"
                                size="small"
                                onBlur={(e) => {
                                    let inputDate = moment(e.target.value, 'DD-MM-YYYY').format('DD-MM-YYYY');

                                    if (inputDate === 'Invalid date' || (endTime && moment(endTime, 'DD-MM-YYYY').isBefore(moment(e.target.value, 'DD-MM-YYYY')))) {
                                        handleChangeDate(null, startFieldName);
                                    } else {
                                        handleChangeDate(inputDate, startFieldName);
                                    }
                                }}
                                error={isMandatory && (!formatStartTime || formatStartTime === "Invalid date") && errorMsgList.leaveDate}
                                helperText={(!formatStartTime || formatStartTime === "Invalid date") && errorMsgList && errorMsgList.leaveDate}
                                fullWidth
                            />
                        }
                        inputFormat="DD-MM-YYYY"
                        //maxDate={endTime ? formatEndTime : undefined}
                    />
                </LocalizationProvider>
            </Grid>
            <Grid item>leave to 至</Grid>
            <Grid item xs={12} md={2}>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DatePicker
                        id={'DateTimePicker_To_Date'}
                        openTo="year"
                        views={['year', 'month', 'day']}
                        value={formatEndTime}
                        onChange={(valDate) => {
                            handleChangeDate(moment(valDate).format('DD-MM-YYYY'), endFieldName);
                        }}
                        renderInput={(params) =>
                            <TextField {...params}
                                placeholder="DD-MM-YYYY"
                                variant="outlined"
                                size="small"
                                onBlur={(e) => {
                                    let inputDate = moment(e.target.value, 'DD-MM-YYYY').format('DD-MM-YYYY');
                                    if (inputDate === 'Invalid date' || (startTime && moment(startTime, 'DD-MM-YYYY').isAfter(moment(e.target.value, 'DD-MM-YYYY')))) {
                                        handleChangeDate(null, endFieldName);
                                    } else {
                                        handleChangeDate(inputDate, endFieldName);

                                    }
                                }}
                                error={isMandatory && (!formatEndTime || formatEndTime === "Invalid date") && errorMsgList.leaveDate}
                                helperText={(!formatEndTime || formatEndTime === "Invalid date") && errorMsgList && errorMsgList.leaveDate}
                                fullWidth
                            />
                        }
                        inputFormat="DD-MM-YYYY"
                        minDate={startTime ? formatStartTime : undefined}
                    />
                </LocalizationProvider>
            </Grid>
            <Grid item className={classes.time}>
                <RadioGroup row aria-label="timePeriod" name="timePeriod" value={dateValue['period']} onChange={(e) => { handleChangeDate(e.target.value, 'period') }}>
                    <FormControlLabel value="AM" control={<Radio />} label="AM 上午" disabled={!moment(formatStartTime).isSame(moment(formatEndTime))} />
                    <FormControlLabel value="PM" control={<Radio />} label="PM 下午" /* disabled={!moment(formatStartTime).isSame(moment(formatEndTime))} */ />
                </RadioGroup>
                <div>(If applicable 如適用)</div>
            </Grid>
        </Grid>
    )
}